<template>
  <v-text-field
    v-bind="$attrs"
    :value="value"
    @input="$emit('update:value', $event)"
    :label="label"
    :placeholder="placeholder"
    :type="type"
    :maxlength="maxlength"
    :readonly="readonly"
    :rules="rules"
    outlined
    dense
    color="primary"
    class="campo-texto-azul"
    v-on="$listeners"
  >
    <template v-for="(_, slotName) in $scopedSlots" v-slot:[slotName]="slotData">
      <slot :name="slotName" v-bind="slotData"></slot>
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: 'FormTextField',
  
  // Evita que los atributos extra se apliquen al div raíz si existiera uno, 
  // asegurando que vayan directo al v-text-field mediante v-bind="$attrs"
  inheritAttrs: false, 

  model: {
    prop: 'value',
    event: 'update:value'
  },

  // Mantenemos EXACTAMENTE los mismos props para no romper nada en el sistema actual
  props: {
    name: { type: String, default: '' },
    value: { type: String, default: '' },
    type: { type: String, default: 'text' },
    label: { type: String, default: 'TEXT FIELD' },
    rules: { type: Array, default: () => [] },
    placeholder: { type: String, default: '' },
    maxlength: { type: Number, default: 100 },
    readonly: { type: Boolean, default: false },
    defaultValue: { type: String, default: '' }
  },

  emits: ['update:value'],

  // Se eliminaron computed, created y updated para mantener el componente ligero.
}
</script>

<style scoped>
.campo-texto-azul ::v-deep .v-input__control,
.campo-texto-azul ::v-deep .v-input__slot {
  min-height: 56px !important;
}
.campo-texto-azul ::v-deep fieldset {
  border-color: #002245 !important;
  border-width: 1.5px !important;
  border-radius: 8px !important;
}
.campo-texto-azul ::v-deep input {
  color: #002245 !important;
  font-weight: 600;
}
.campo-texto-azul ::v-deep .v-label {
  color: #002245 !important;
  font-weight: 600;
}
.campo-texto-azul ::v-deep .v-icon {
  color: #002245 !important;
}
</style>